export class ListInstanceProfilesResponse {
    'instanceProfileNames';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceProfileNames",
            "baseName": "instanceProfileNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInstanceProfilesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
